import { StackWithDividers } from '@components'

import { Divider, Flex, SkeletonBox, Spacing, Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { DocumentCustomerLink } from './elements/DocumentCustomerLink'
import { DocumentDetailsCardEntry } from './elements/DocumentDetailsCardEntry'
import * as Styled from './styles'

const SKELETON_BOX_WIDTH = 218
const SKELETON_BOX_HEIGHT = 136

interface DocumentDetailsCardProps {
  children: ReactNode[]
  isLoading: boolean
  title?: string
}

export const DocumentDetailsCard = ({ children, isLoading, title }: DocumentDetailsCardProps): ReactElement => {
  if (isLoading) {
    return <SkeletonBox width={SKELETON_BOX_WIDTH} height={SKELETON_BOX_HEIGHT} />
  }

  return (
    <Styled.DocumentDetailsCardWrapper>
      <Flex alignItems="stretch" flexDirection="column" gap={Spacing.S12}>
        {title && (
          <Styled.DocumentDetailsCardTitle>
            <Text alignment="left" variant="bodyLG" weight="medium">
              {title}
            </Text>
          </Styled.DocumentDetailsCardTitle>
        )}
        <StackWithDividers divider={<Divider />}>{children}</StackWithDividers>
      </Flex>
    </Styled.DocumentDetailsCardWrapper>
  )
}

DocumentDetailsCard.CustomerLink = DocumentCustomerLink
DocumentDetailsCard.Entry = DocumentDetailsCardEntry
